import React, { useCallback, useMemo, useState } from 'react'
import { FormValues } from 'donate/types'
import { I18nHtml, Modal, TrustedHtml } from 'shared'
import { MonthlyMatchingFundBannerProps } from './types'
import { connect } from 'formik'

export const MonthlyMatchingFundBanner = connect<MonthlyMatchingFundBannerProps, FormValues>(({ formik, config }) => {
  const [showDetails, setShowDetails] = useState(false)
  const handleClick = useCallback(() => {
    setShowDetails(true)
    ;(document.activeElement as HTMLInputElement | null)?.blur()
  }, [])

  const bannerText = useMemo(() => {
    return formik.values.interval === 'monthly'
      ? i18n.t('donate.monthly_matching_fund_banner_monthly_html')
      : i18n.t('donate.monthly_matching_fund_banner_html')
  }, [formik.values.interval])
  const hideDetails = useCallback(() => setShowDetails(false), [])
  if (!config.showMonthlyMatching) return null

  return (
    <div className="matching-funds-monthly-donation-form-banner">
      <p className="mb-0">
        <TrustedHtml as="span" value={bannerText} />{' '}
        <button type="button" className="gentle-link" onClick={handleClick}>
          {i18n.t('donate.learn_more')}
        </button>
      </p>
      <Modal
        id="matching-fund"
        show={showDetails}
        onHide={hideDetails}
        header={i18n.t('donate.monthly_matching_fund_banner_modal_header')}
        content={<I18nHtml as="span" i18nKey="donate.monthly_matching_fund_banner_modal_content_html" />}
      />
    </div>
  )
})
